/* eslint-disable react/button-has-type */
import { DownloadOutlined, FilePdfOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Card, Space, Typography } from 'antd';
import Meta from 'antd/lib/card/Meta';
import _ from 'lodash';
import React, { useState } from 'react';
import nextId from 'react-id-generator';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { useTranslation } from 'react-i18next';
import { importPdf } from '../../../../services/ML/OCR/importPdf';
import { impOcrRested } from '../../../../store/impOcr';
import { BetaTag, RowSm } from '../../../../styles';
import AnimOpacity from '../../../UI/Anim/AnimOpacity';
import ImpCard from '../../ImpCard';
import FilePreview, { PlusButton } from './FilePreview';
import ImpOrcInboxActions from './ImpOrcInboxActions';

const { Paragraph } = Typography ;

const Desc = () => {
  const { t } = useTranslation();
  return (
    <Paragraph>
      {t('impOcr.desc1')}
      {' '}
      <strong>
        {' '}
        {t('impOcr.desc2')}
      </strong>
      {t('impOcr.desc3')}
      {' '}
      <strong>
        l
        {' '}
        {t('impOcr.desc4')}
      </strong>
      {' '}
      {t('impOcr.desc5')}
    </Paragraph>
  );
};


const ImpOcrFiles = () => {
  const hiddenFileInput = React.useRef<HTMLInputElement>(null);

  const { i18n, t } = useTranslation();

  const [files, setFiles] = useState<File[]>([]);

  const history = useHistory();

  const dispatch = useDispatch();

  const handleClick = () => {
    if (hiddenFileInput.current && hiddenFileInput) {
      hiddenFileInput.current.click();
    }
  };

  const onFileAdd = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files){
      setFiles([...files, event.target.files[0]]);
    }
  };

  const onAccept = () => {
    importPdf({
      files,
      dispatch,
      isPL: i18n.language === 'pl'
    });
    setFiles([]);
  };

  const onBack = () => {
    history.goBack();
    dispatch(impOcrRested());
  };

  return (
    <ImpCard
      title={(
        <Space>
          {t('impOcr.title')}
          <BetaTag>BETA</BetaTag>
        </Space>
)}
      desc={<Desc />}
      icon={<FilePdfOutlined />}
    >
      <AnimOpacity>
        <ImpOrcInboxActions
          {...{
            onBack,
            onAccept,
            numberOfFiles: files.length
          }}
        />
        <RowSm>
          {_.isEmpty(files) ? null : files.map((file, index) =>
            (
              <FilePreview
                key={nextId()}
                file={file}
                removeFile={() =>
                  setFiles(files.filter((v, idx) =>
                    index !== idx))}
              />
            ))}
          <input
            type="file"
            ref={hiddenFileInput}
            onChange={(event) =>
              onFileAdd(event)}
            style={{ display: 'none' }}
            accept="image/png, image/jpeg, image/jpg, .pdf"
          />
          <PlusButton onClick={handleClick}>
            <div>
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>
                {t('impOcr.add')}
              </div>
            </div>
          </PlusButton>
        </RowSm>
      </AnimOpacity>

      <Card
        title={t('ImpOcrFiles.title')}
        style={{ marginTop: 24 }}
      >
        <Meta
          title={(
            <>
              {t('ImpOcrFiles.files')}
              {' '}
            </>
)}
          description={(
            <>
              <Button
                type='link'
                icon={<DownloadOutlined />}
                href="https://firebasestorage.googleapis.com/v0/b/pozewapp.appspot.com/o/one.pdf?alt=media&token=1570d0c3-2959-48ab-a785-c87a71f8e71c"
                target='_blank'
              >
                {t('ImpOcrFiles.one')}
              </Button>
              |
              <Button
                type="link"
                icon={<DownloadOutlined />}
                target='_blank'
                href="https://firebasestorage.googleapis.com/v0/b/pozewapp.appspot.com/o/many_invoices.pdf?alt=media&token=8357b52f-2d0f-4c4c-86e0-ef6f89e01a59"
              >

                {t('ImpOcrFiles.two')}
              </Button>
              <br />
            </>
        )}
        />
        <Meta
          style={{ marginTop: 12 }}
          description={(
            <>
              {t('ImpOcrFiles.desc1')}
              {' '}
              <strong>
                {' '}
                {t('ImpOcrFiles.desc2')}
              </strong>
              {t('ImpOcrFiles.desc3')}
              {' '}
              <strong>
                {' '}
                {t('ImpOcrFiles.desc4')}
              </strong>
              {' '}
              .
              {' '}
              {t('ImpOcrFiles.desc4')}
              .
              <br />
            </>
        )}
        />

      </Card>


    </ImpCard>
  );
};

export default ImpOcrFiles;
